<span class="app-advance-indicator-form">

    <form autocomplete="off" class="advance-indicator-form-wrapper display-flex"
        *ngFor="let row of inputs;let idx = index;">

        <div [class.first-form]="idx == 0">
            <mat-form-field class="margin-8 condensed-select-field dense-form-feild " *ngIf="idx != 0"
                appearance="outline" color="accent">

                <mat-select [formControl]="andOrControls[idx - 1]">
                    <mat-option [value]="option.key" *ngFor="let option of AND_OR | keyvalue">
                        {{ option.value }}
                    </mat-option>
                </mat-select>

                <mat-error *ngIf="andOrControls[idx - 1].hasError('required')">
                    Comparator is required
                </mat-error>
                <mat-hint class="mat-error" *ngIf="isLastConditionError">Please fill last conditions first
                </mat-hint>
            </mat-form-field>

            <button class="added-inputs-display margin-8" mat-raised-button
                *ngFor="let input of row;let inputIdx = index" (click)="updateInputValues(input)">
                {{ input.value }}

                <mat-icon class="close-icon flex-centered-container mat-elevation-z6" appPreventDefault
                    *ngIf="(idx === (inputs.length - 1)) && (inputIdx === (row.length - 1)) && !showAddInput"
                    (click)="removeLast(idx)">
                    close
                </mat-icon>
            </button>
        </div>

        <div class="margin-8" *ngIf="showAddInput && (idx === (inputs.length - 1))">

            <div class="position-relative">
                <mat-form-field class="full-width dense-form-feild condensed-select-field" appearance="outline"
                    color="accent">
                    <mat-label>Select Option</mat-label>

                    <input #matMenuTrigger matInput type="text" [matMenuTriggerFor]="menuRef" [formControl]="userInput"
                        (keydown.enter)="enterPress()" (focus)="openIndicatorMenu()" (focusout)="enterPress()"
                        (keydown)="checkFilterEvent($event)">
                </mat-form-field>

                <mat-icon class="close-icon flex-centered-container mat-elevation-z6 cursor-pointer"
                    (click)="removeLast(idx)" appPreventDefault>
                    close
                </mat-icon>
            </div>

            <mat-menu #menuRef="matMenu" class="indicator-menu" yPosition="above" xPosition="after">
                <button mat-menu-item *ngFor="let panel of menuOptions | keyvalue"
                    (click)="openAdvanceSymbolSearch(panel.key, $event)" [matMenuTriggerFor]="tempRef">
                    <span class="text-dark cursor-pointer">
                        {{ panel.key }}
                    </span>
                    <mat-menu #tempRef class="indicator-menu">
                        <ng-container *ngIf="panel.key===ADVANCE_INDICATOR_INPUT_TYPE.INDICATOR">
                            <button mat-menu-item *ngFor="let item of panel.value,let i=index;"
                                (click)="addInput(panel.key, item)">
                                <span class="padding-right" [matTooltip]="indicatorDescription[i]"
                                    matTooltipPosition="right">
                                    {{ item }}
                                </span>
                            </button>
                        </ng-container>
                        <ng-container *ngIf="panel.key!==ADVANCE_INDICATOR_INPUT_TYPE.INDICATOR">
                            <button mat-menu-item *ngFor="let item of panel.value" (click)="addInput(panel.key, item)">
                                {{ item }}
                            </button>
                        </ng-container>
                    </mat-menu>
                </button>
            </mat-menu>
        </div>

        <div class="flex-centered-container add-remove" *ngIf="idx === (inputs.length - 1)">
            <button mat-stroked-button color="accent" type="button" (click)="showAddInput = true;" *ngIf="!showAddInput"
                class="flex-centered-container chamfer">
                <mat-icon>add</mat-icon>
            </button>
            <button mat-stroked-button color="warn" type="button" class="flex-centered-container chamfer"
                (click)="removeRow()" [disabled]="isRemoveDisabled">
                <mat-icon>clear</mat-icon>
            </button>
        </div>
    </form>
    <span class="add-new-button cursor-pointer margin-8" (click)="addNewIndicatorRow()">+ Add another condition</span>
</span>